module.exports = __webpack_public_path__ + "img/DSC_1134.26b81468.jpg";